/**
 * todo 加解密工具
 */
const staticchars = "PXhw7UT1B0a9kQDKZsjIASmOezxYG4CHo5Jyfg2b8FLpEvRr3WtVnlqMidu6cN";
export default {


  /** todo 加锁
   * @return {string}
   */
  lock(_str) {
    let encodechars = "";
    for (let i = 0; i < _str.length; i++) {
      let num0 = staticchars.indexOf(_str[i]);
      let code = "";
      if (num0 === -1) {
        code = _str[i];
      } else {
        code = staticchars[(num0 + 3) % 62];
      }
      let num1 = parseInt(Math.random() * 62, 10);
      let num2 = parseInt(Math.random() * 62, 10);
      encodechars += staticchars[num1] + code + staticchars[num2];
    }
    return encodechars;
  },


//todo 解锁
  unlock(_str) {
    let decodechars = "";
    for (let i = 1; i < _str.length;) {
      let num0 = staticchars.indexOf(_str[i]);
      let code = ""
      if (num0 === -1) {
        code = _str[i];
      } else {
        code = staticchars[(num0 + 59) % 62];
      }
      decodechars += code;
      i = i + 3;
    }
    return decodechars;
  },


}





// WEBPACK FOOTER //
// ./src/utils/cdUtils/privacy.js